import { z } from 'zod';

/**
 * Contratto pubblico di GET /api/storage/quota/me.
 *
 * Il servizio backend usa Date internamente e PostgreSQL può restituire i
 * bigint come stringhe; la rotta serializza entrambi prima di validare questo
 * schema. Sul wire i byte e le percentuali sono sempre numeri e le date sono
 * sempre stringhe ISO (o null).
 */
export const quotaStatusSchema = z.enum(['ok', 'info', 'warning', 'critical', 'grace', 'blocked']);
export type QuotaStatus = z.infer<typeof quotaStatusSchema>;

export const quotaCategorySchema = z.enum(['embedding', 'upload', 'export']);
export type QuotaCategory = z.infer<typeof quotaCategorySchema>;

export const quotaScopeSchema = z.enum(['r2', 'db']);
export type QuotaScope = z.infer<typeof quotaScopeSchema>;

export const quotaScopeSnapshotSchema = z.object({
  scope: quotaScopeSchema,
  usedBytes: z.number().finite(),
  maxBytes: z.number().finite(),
  pct: z.number().finite(),
  status: quotaStatusSchema,
  hardBlockedSince: z.string().datetime().nullable(),
  lastCalcAt: z.string().datetime().nullable(),
});
export type QuotaScopeSnapshot = z.infer<typeof quotaScopeSnapshotSchema>;

export const storageQuotaSnapshotResponseSchema = z.object({
  tenantId: z.string(),
  r2: quotaScopeSnapshotSchema,
  db: quotaScopeSnapshotSchema.nullable(),
  blockedCategories: z.array(quotaCategorySchema),
  emergencyUnblockUntil: z.string().datetime().nullable(),
  schemaReady: z.boolean(),
  embedderProvider: z.enum(['openai', 'gemini']).nullable(),
});
export type StorageQuotaSnapshot = z.infer<typeof storageQuotaSnapshotResponseSchema>;